import { AbstractBlock } from '../AbstractBlock';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { ShapeSettings } from '../setting/ShapeSettings';
import { BlockType } from '../../@types/BlockType';

/**
 * VRPositionAttribute
 */
export class VR3InputAttribute extends AbstractBlock {
  private defaultX = 0;
  private defaultY = 0;
  private defaultZ = 0;
  private labelX = 'X:';
  private labelY = 'Y:';
  private labelZ = 'Z:';
  private isAngle = false;

  constructor(name: string, title: string, isAngle = false) {
    super(name, title);
    this.isAngle = isAngle;
  }

  setDefaultXYZ(x: number, y: number, z: number): VR3InputAttribute {
    this.defaultX = x;
    this.defaultY = y;
    this.defaultZ = z;
    return this;
  }

  setLabelXYZ(x: string, y: string, z: string): VR3InputAttribute {
    this.labelX = x;
    this.labelY = y;
    this.labelZ = z;
    return this;
  }

  defineBlock(block: BlockType): void {
    ColorSettings.setAttributeColor(block);
    ShapeSettings.setAttributeShape(block);

    ShapeSettings.setTitleField(block, this.title);
    ShapeSettings.setVR3Fields(block, this.name_for_code, this.defaultX, this.defaultY, this.defaultZ);
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    let str = CodeSetting.getVR3FieldValues(block, this.name_for_code);
    str += CodeSetting.getSubAttributeCode(block);
    return [str];
  }
}
